import { FC, PropsWithChildren } from 'react'

export const WebViewRoute: FC<PropsWithChildren> = ({ children }) => {
    return children
}
